/**
 * Centellian24 Extra Credit promotion (SSD-6088).
 *
 * Every Centellian24 purchase made inside the window earns extra store credit,
 * settled after the promotion ends. The storefront surfaces it as a seal badge
 * on product thumbnails; the header flag banner (SSD-6083) carries the same
 * percentage, so the two must be changed together.
 *
 * The window intentionally matches the banner rotation entry in
 * `holidayBanner.ts` — midnight-to-midnight so Aug 27 and Aug 31 are both
 * covered in full.
 */
export const CENTELLIAN24_CREDIT_CAMPAIGN = {
  startDate: '2026-08-27 00:00:00',
  endDate: '2026-09-01 00:00:00',
  timeZone: 'Asia/Singapore',
} as const;

/**
 * Brand name as it appears in `allBrands` and in the product API `brand` field.
 * Compared through `normalizeBrandName`, so spacing and casing drift is tolerated.
 */
export const CENTELLIAN24_BRAND_NAME = 'Centellian24';

/**
 * Centellian24 SKUs the promotion does not cover.
 *
 * The campaign is brand-wide, so this is an exclusion list rather than an
 * allowlist: a 130-SKU allowlist goes stale the moment the catalogue changes,
 * whereas the handful of brand products outside the promotion are stable.
 * These two are EU/UK/AU-exclusive and are absent from the promotion's product
 * sheet.
 */
export const CENTELLIAN24_CREDIT_EXCLUDED_SKUS: readonly string[] = [
  // [EU EXCLUSIVE] Madeca Prime Max (Silver)
  '1000572747',
  // [EU EXCLUSIVE] Madeca Prime Max (Lavender)
  '1000572748',
];

/**
 * Extra credit percentage shown on the badge. A single flat rate for the whole
 * brand — per-SKU rates were considered and dropped for this promotion.
 * Set to 0 to switch the badge off without touching the window.
 */
export const CENTELLIAN24_CREDIT_PERCENTAGE: number = 20;
